export default "__VITE_ASSET__BR72NP7m__"